const PlayerStateData = require('./PlayerStateData');
const { DeckDataFactory } = require('../Factories/DeckDataFactory');
const { Age } = require("../Constants/Constants")
const { Phase } = require('../Moves/MoveTypes');

const CARD_ROW_SIZE = 13;

const { DefaultSetup, CardSets, PickLeadersAndWonders } = require('../Constants/CardVersions');

class GameStateData {
    // setup: the leaders and wonders in the game, and the versions of those the expansion changed (see
    // Constants/CardVersions.js; the expansion's, with every leader and wonder, unless given)
    constructor(players, setup = DefaultSetup){
        this.playerCount = players.length;
        this.setup = { ...DefaultSetup, ...setup, overrides: { ...(setup.overrides ?? {}) } };
        // A mix: its leaders and wonders, picked now (what the players may know of them: Server/Views.js)
        if (this.setup.cards === CardSets.Mix && !this.setup.selection)
        {
            this.setup.selection = PickLeadersAndWonders(this.playerCount, Math.random, this.setup);
        }
        this.playerStateData = players.map( (p,i) => new PlayerStateData(p.name,i))
        this.age = Age.AgeA;

        // Age A: 13 civil cards in the row, the rest become the civil deck
        this.civilDeck = shuffleArray(DeckDataFactory.GetCivilDeck(Age.AgeA, this.playerCount, this.setup));
        this.civilCardRow = this.civilDeck.splice(0, CARD_ROW_SIZE);

        // Age A military cards only seed the current events; there is no military deck to draw from in Age A
        const ageAEvents = shuffleArray(DeckDataFactory.GetMilitaryDeck(Age.AgeA, this.playerCount, this.setup));
        this.currentEvents = ageAEvents.slice(0, this.playerCount + 2);
        // The rest stay in the box, out of the game (Development of Planning draws from them)
        this.eventBox = ageAEvents.slice(this.playerCount + 2);
        this.futureEvents = [];
        this.militaryDeck = [];
        this.publicTactics = [];
        this.tacticBonuses = {};

        // Later ages' decks, shuffled now so replaying moves always deals the same cards.
        // Each one comes into play when the civil deck before it runs out.
        this.upcomingDecks = [Age.Age1, Age.Age2, Age.Age3].map(age => ({
            age,
            civil: shuffleArray(DeckDataFactory.GetCivilDeck(age, this.playerCount, this.setup)),
            military: shuffleArray(DeckDataFactory.GetMilitaryDeck(age, this.playerCount, this.setup)),
        }));

        this.currentPlayer = 0;
        // There is no political phase in the first round
        this.phase = Phase.Action;
        this.round = 1;

        // Seed for the game's random choices after setup (e.g. reshuffling future events), so replays match
        this.rngSeed = Math.floor(Math.random() * 2147483647);

        this.nextCardId = 1;
        this.assignCardIds();
    }

    assignCardIds() {
        const assign = (card) => {
            if (card && card.id == null) {
                card.id = this.nextCardId++;
            }
        };
        [this.currentEvents, this.eventBox, this.futureEvents, this.civilCardRow, this.militaryDeck, this.civilDeck,
            ...this.upcomingDecks.flatMap(deck => [deck.civil, deck.military])]
            .forEach(cards => cards.forEach(assign));
        this.playerStateData.forEach(p => {
            p.civilHand.forEach(assign);
            p.militaryHand.forEach(assign);
        });
    }
}

function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}

module.exports = GameStateData;